/**
 * Returns a cryptographically secure random integer between min and max (inclusive).
 */
function getCryptoRandomBetween(min, max) {
  const MAX_VAL = 4294967295; // max value of Uint32
  const numberOfRandomsNeeded = Math.ceil((max - min) / MAX_VAL);
  const cryptoRandomNumbers = new Uint32Array(numberOfRandomsNeeded);
  crypto.getRandomValues(cryptoRandomNumbers);
  let sum = 0;
  for (let i = 0; i < cryptoRandomNumbers.length; i++) {
    sum += cryptoRandomNumbers[i];
  }
  const randomDecimal = sum / (MAX_VAL * numberOfRandomsNeeded);
  return randomDecimal === 1
    ? getCryptoRandomBetween(min, max)
    : Math.floor(randomDecimal * (max - min + 1) + min);
}

/**
 * Generates a cryptographically secure random password.
 * @param {number} length - Number of characters in the password.
 * @param {string} characters - Character set to pick from.
 * @returns {string}
 */
export function generateRandomPassword(length, characters) {
  let str = '';
  for (let i = 0; i < length; i++) {
    str += characters.charAt(getCryptoRandomBetween(0, characters.length - 1));
  }
  return str;
}

/**
 * A random v4 UUID. crypto.randomUUID only exists in secure contexts (HTTPS or
 * localhost), so a page opened over plain http on the LAN (the local demo on a
 * scanner phone) builds one from crypto.getRandomValues, which works anywhere.
 */
export function randomUUID() {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
